import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import NewModal from "../NewModal/NewModal";
import Modal from "../Modal";
import Form from "../Form/Form";
import FormInput from "../Inputs/FormInput/FormInput";
import { useHttp } from "../../hooks/http.hook";
import { AuthContext } from "../../context/AuthContext";
import DateInput from "../DateInput";
import moment from "moment";

EditPatientModal.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  initialForm: PropTypes.object,
  API: PropTypes.string,
};

function EditPatientModal({ closeHandler, initialForm, API }) {
  const [form, setForm] = useState(initialForm);
  const { request } = useHttp();
  const { token } = useContext(AuthContext);
  const [status, setStatus] = useState();
  const [error, setError] = useState();

  const changeHandler = (event, name) => {
    setForm({ ...form, [event.target.name || name]: event.target.value });
  };
  const dobChangeHandler = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  async function submitHandler(e) {
    e.preventDefault();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { data, status } = await request(
      baseUrl + API.api,
      API.method,
      form,
      { Authorization: `Bearer ${token.token}` }
    );

    if (status < 300 && status >= 200) {
      setError(data?.message);
      if (data.message === "Ok") {
        setStatus(200);
      }
    }
  }

  return (
    <Modal mobile={true}>
      <NewModal
        error={error}
        completed={status === 200}
        completedText={"Сохранено!"}
        completedButtonText={"Продолжить"}
        title={"Пациент"}
        closeHandler={closeHandler}
      >
        <Form submitHandler={submitHandler} submitButtonText={"Сохранить"}>
          <FormInput
            hideIcon
            name="fio"
            value={form.fio}
            onChange={changeHandler}
            title={"ФИО"}
          />
          <DateInput
            hideIcon
            name="dob"
            value={moment(form.dob, "YYYY-MM-DD").format()}
            onChange={(date) =>
              dobChangeHandler("dob", moment(date, "YYYY-MM-DD").format())
            }
            type={"date"}
            title={"Дата рождения"}
          />
          <FormInput
            hideIcon
            name="jobName"
            value={form.jobName}
            onChange={()=>{}/*changeHandler*/}
            title={"Место работы"}
          />
        </Form>
      </NewModal>
    </Modal>
  );
}

export default EditPatientModal;
